var _tspan, _tspan2, _tspan3, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 250,
    viewBox: "0 0 79.375 66.146",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.26 -23.282)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0698 0 0 1.0698 -11.621 -56.463)",
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "40px",
    style: {
      lineHeight: 1.25,
      shapeInside: "url(#rect5930)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 20.369141,
    y: 103.70117
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#41494c"
  }, "4")))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0698 0 0 1.0698 44.581 -56.39)",
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "40px",
    style: {
      lineHeight: 1.25,
      shapeInside: "url(#rect5930-0)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 20.369141,
    y: 103.70117
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#41494c"
  }, "4")))), /*#__PURE__*/React.createElement("text", {
    x: 155.30005,
    y: 80.794891,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "10.583px",
    strokeWidth: 0.26458,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 155.30005,
    y: 80.794891,
    strokeWidth: 0.26458
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.27072 0 0 .27072 31.988 47.019)",
    fill: "#ff4500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gear1",
    d: "m117.59-25.618 11.837-2.1562c0.032-3.4082-0.2331-6.7975-0.78013-10.129l-12.025-0.36093c-0.83465-3.9063-2.1618-7.7036-3.9514-11.285l9.1718-7.7882c-1.6524-2.9532-3.5642-5.7598-5.7185-8.4029l-10.597 5.7053c-2.6337-2.9307-5.6696-5.5587-9.0778-7.7995l4.0417-11.326c-1.4456-0.85909-2.9363-1.6712-4.4853-2.4137-1.5415-0.74254-3.0942-1.393-4.6601-1.9908l-6.3257 10.24c-3.8762-1.2651-7.8258-2.002-11.764-2.2351l-2.1599-11.836c-3.4082-0.0376-6.7938 0.22558-10.123 0.77262l-0.36281 12.025c-3.912 0.83465-7.7092 2.1618-11.294 3.9552l-7.7938-9.1699c-2.942 1.658-5.7504 3.5679-8.3841 5.7185l5.6997 10.589c-2.9307 2.6337-5.5662 5.6809-7.807 9.0909-4.1093-1.4663-7.9856-2.8498-11.328-4.0454-0.85345 1.455-1.6637 2.9363-2.4062 4.4778-0.74254 1.5415-1.3948 3.0999-1.9964 4.6733 3.0209 1.8667 6.5155 4.0304 10.232 6.3257-1.2595 3.8762-1.9964 7.8314-2.2314 11.77l-11.83 2.1599c-0.0376 3.4044 0.22746 6.7862 0.7745 10.123l12.025 0.35529c0.84029 3.9195 2.1731 7.7205 3.9608 11.296l-9.168 7.7901c1.6599 2.9476 3.5642 5.7561 5.726 8.3954l10.584-5.7053c2.6468 2.9307 5.6865 5.5587 9.089 7.7995l-4.0341 11.326c1.4381 0.84781 2.925 1.658 4.4665 2.3949 1.5471 0.74818 3.1074 1.4061 4.6846 1.9964l6.3276-10.226c3.8687 1.2595 7.8183 1.9964 11.749 2.2257l2.1618 11.836c3.4082 0.0376 6.7919-0.2331 10.129-0.7745l0.36845-12.031c3.9063-0.83465 7.6961-2.1618 11.277-3.9552l7.7882 9.1642c2.9476-1.6449 5.7561-3.5567 8.3973-5.7053l-5.6997-10.602c2.925-2.6337 5.5455-5.6696 7.7882-9.0778l11.326 4.0473c0.85345-1.4494 1.6712-2.942 2.4137-4.4834 0.7369-1.5358 1.3873-3.1017 1.9908-4.6752l-10.232-6.3257c1.2576-3.8725 1.9926-7.8164 2.2257-11.753zm-25.637 7.5363c-5.7128 11.879-19.968 16.879-31.846 11.161-11.879-5.7053-16.879-19.962-11.161-31.841 5.711-11.879 19.968-16.879 31.841-11.166 11.879 5.7128 16.881 19.968 11.166 31.846z",
    fill: "#ff4500",
    strokeWidth: 1.8798
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35019 0 0 .35019 42.244 78.702)",
    fill: "#41494c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gear2",
    d: "m117.59-25.618 11.837-2.1562c0.032-3.4082-0.2331-6.7975-0.78013-10.129l-12.025-0.36093c-0.83465-3.9063-2.1618-7.7036-3.9514-11.285l9.1718-7.7882c-1.6524-2.9532-3.5642-5.7598-5.7185-8.4029l-10.597 5.7053c-2.6337-2.9307-5.6696-5.5587-9.0778-7.7995l4.0417-11.326c-1.4456-0.85909-2.9363-1.6712-4.4853-2.4137-1.5415-0.74254-3.0942-1.393-4.6601-1.9908l-6.3257 10.24c-3.8762-1.2651-7.8258-2.002-11.764-2.2351l-2.1599-11.836c-3.4082-0.0376-6.7938 0.22558-10.123 0.77262l-0.36281 12.025c-3.912 0.83465-7.7092 2.1618-11.294 3.9552l-7.7938-9.1699c-2.942 1.658-5.7504 3.5679-8.3841 5.7185l5.6997 10.589c-2.9307 2.6337-5.5662 5.6809-7.807 9.0909-4.1093-1.4663-7.9856-2.8498-11.328-4.0454-0.85345 1.455-1.6637 2.9363-2.4062 4.4778-0.74254 1.5415-1.3948 3.0999-1.9964 4.6733 3.0209 1.8667 6.5155 4.0304 10.232 6.3257-1.2595 3.8762-1.9964 7.8314-2.2314 11.77l-11.83 2.1599c-0.0376 3.4044 0.22746 6.7862 0.7745 10.123l12.025 0.35529c0.84029 3.9195 2.1731 7.7205 3.9608 11.296l-9.168 7.7901c1.6599 2.9476 3.5642 5.7561 5.726 8.3954l10.584-5.7053c2.6468 2.9307 5.6865 5.5587 9.089 7.7995l-4.0341 11.326c1.4381 0.84781 2.925 1.658 4.4665 2.3949 1.5471 0.74818 3.1074 1.4061 4.6846 1.9964l6.3276-10.226c3.8687 1.2595 7.8183 1.9964 11.749 2.2257l2.1618 11.836c3.4082 0.0376 6.7919-0.2331 10.129-0.7745l0.36845-12.031c3.9063-0.83465 7.6961-2.1618 11.277-3.9552l7.7882 9.1642c2.9476-1.6449 5.7561-3.5567 8.3973-5.7053l-5.6997-10.602c2.925-2.6337 5.5455-5.6696 7.7882-9.0778l11.326 4.0473c0.85345-1.4494 1.6712-2.942 2.4137-4.4834 0.7369-1.5358 1.3873-3.1017 1.9908-4.6752l-10.232-6.3257c1.2576-3.8725 1.9926-7.8164 2.2257-11.753zm-25.637 7.5363c-5.7128 11.879-19.968 16.879-31.846 11.161-11.879-5.7053-16.879-19.962-11.161-31.841 5.711-11.879 19.968-16.879 31.841-11.166 11.879 5.7128 16.881 19.968 11.166 31.846z",
    fill: "#41494c",
    strokeWidth: 1.8798
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.785d94916c9fb63a7fdee036ffd982b6.svg";
export { ForwardRef as ReactComponent };